import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PageMoveService {

  notice:any;
  
  constructor(
    private router:Router,

  ) { }

  goPage(url:string):void{
    this.router.navigateByUrl(url);
  }
  goRecruitEdit(notice:any):void{
  this.notice = notice;
    this.router.navigateByUrl('/admin/recruitEdit');
  }
  goNoticeEdit(notice:any):void{
    this.notice = notice;
    this.router.navigateByUrl('/admin/noticeEdit');
  }
  reload():void{
    this.router.onSameUrlNavigation='reload';
  }
  goRecruitDetail(notice:any){
    this.notice =notice
    setTimeout(() => {
      this.router.navigateByUrl('/recruitDetail');
    }); 
  
  }
  goNoticeDetail(notice:any){
    this.notice = notice;
    setTimeout(() => {
    this.router.navigateByUrl('/noticeDetail');
    }); 
  }
}
